<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Review</h1>

      <breadcrumb name="LUCKY_LOGIN_REVIEW"></breadcrumb>

      <div class="page-header-right">
        Selected Period
        <date-picker
          v-model="fromTo"
          type="date"
          value-type="format"
          format="YYYY-MM-DD"
          range
          class="mx-3"
          placeholder="Select date range"
        ></date-picker>
      </div>
      <div class="page-header-actions"></div>
    </div>

    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <vue-good-table
              ref="table"
              mode="remote"
              :rows="list"
              :columns="columns"
              :totalRows="totalRecords"
              :sort-options="sortOption"
              :search-options="searchOption"
              :pagination-options="pagination"
              @on-search="onSearch"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPerPageChange"
            >
              <div slot="table-actions">
                <button
                  @click="exportToExcel"
                  class="btn btn-default"
                  :disabled="list.length <= 0"
                >
                  <i class="fa fa-file-excel-o"></i>
                  Export to Excel
                </button>
              </div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import vueGoodTableMixins from "@/mixins/vue-good-table";

import { luckyLoginService } from "@/api/client";
import { reviewTableColumns } from "@/views/luckylogin/review/model";

export default {
  name: "Review",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      fromTo: [],
      transactions: [],
      columns: reviewTableColumns,
    };
  },

  watch: {
    fromTo() {
      this.onDateChange();
    },

    transactions(v) {
      this.list = v;
    },

    async "$route.query"() {
      await this.fetch();
      this.initialTableState();
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
  },

  methods: {
    async update() {
      this.listwinner = await luckyLoginService.getWinnerList({
        from: this.fromTo[0],
        to: this.fromTo[1],
      });
    },

    getParams() {
      let params = {
        from: this.fromTo[0],
        to: this.fromTo[1],
      };

      const { sortBy, sortDir, perPage, page, searchTerm } = this.$route.query;

      const pageSize = perPage || this.pagination.perPage;

      if (sortBy) {
        params.order_by = sortBy;
      }

      if (sortDir) {
        params.desc = sortDir == "desc" ? 1 : 0;
      }

      if (searchTerm) {
        params.search = searchTerm;
      }

      if (page) {
        params.start = page ? (page - 1) * pageSize : 0;
      }

      params.count = pageSize || 10;

      return params;
    },

    isValidDate() {
      const { from, to } = this.$route.query;

      if (!from || !moment(from).isValid()) {
        return false;
      }

      if (!to || !moment(to).isValid()) {
        return false;
      }

      return true;
    },

    async fetch() {
      if (!this.isValidDate()) {
        return;
      }

      const params = this.getParams();

      const { data, count } = await luckyLoginService.getReviewList(params);

      this.transactions = data;
      this.totalRecords = count;
    },

    async exportToExcel() {
      try {
        const response = await luckyLoginService.downloadReview({
          from: this.fromTo[0],
          to: this.fromTo[1],
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });

        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = `export_lucky_login_review_${new Date().getTime()}.xlsx`;
        a.click();
      } catch (error) {
        console.log(error);
      }
    },

    onDateChange() {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            from: this.fromTo[0],
            to: this.fromTo[1],
          }),
        })
        .catch((err) => {});
    },

    lastmonth() {
      var today = new Date();
      var lastmonth = new Date(today.getTime() - 24 * 60 * 60 * 1000 * 30 * 3)
        .toJSON()
        .slice(0, 10);
      return lastmonth;
    },

    today() {
      var today = new Date().toJSON().slice(0, 10);
      return today;
    },
  },

  created() {
    // this.fromTo = [this.lastmonth(), this.today()];
  },
};
</script>

<style scoped>
.page-header-right {
  position: absolute;
  top: 40px;
  bottom: 0;
  right: 30px;
}
.page-header-actions {
  margin-top: 40px;
  position: absolute;
  bottom: 20px;
}
.panel {
  margin-top: 3px;
}
.show_entries {
  margin-top: 20px;
}
.Excel {
  margin-top: 35px;
}
</style>
